import type { ActionTab } from "./action-tab";

export function actionTabSwitchProps(
  from: ActionTab,
  to: ActionTab,
  teenId: string | null,
): Record<string, unknown> {
  return { from_tab: from, to_tab: to, teen_id: teenId };
}

export function actionCollapseProps(
  collapsed: boolean,
  teenId: string | null,
): Record<string, unknown> {
  return { state: collapsed ? "collapsed" : "expanded", teen_id: teenId };
}

export function actionSuggestionProps(
  kind: string | null,
  teenId: string | null,
): Record<string, unknown> {
  return { suggestion_kind: kind, teen_id: teenId };
}

export type ActionNoteSource = "mentor" | "ai";

export function actionNoteProps(
  source: ActionNoteSource,
  teenId: string | null,
): Record<string, unknown> {
  return { note_source: source, teen_id: teenId };
}

export function actionNotesSearchProps(
  resultCount: number,
  teenId: string | null,
): Record<string, unknown> {
  return { result_count: resultCount, teen_id: teenId };
}

export type ActionToolGroup = "activity" | "content";

export function actionToolProps(
  group: ActionToolGroup,
  toolId: string,
  teenId: string | null,
): Record<string, unknown> {
  return { tool_group: group, tool_id: toolId, teen_id: teenId };
}

export type ActionHistoryView = "list" | "calendar";

export function actionHistoryViewProps(
  view: ActionHistoryView,
  teenId: string | null,
): Record<string, unknown> {
  return { view, teen_id: teenId };
}

export function actionHistoryEntryProps(
  group: ActionToolGroup,
  toolId: string,
  teenId: string | null,
): Record<string, unknown> {
  return { entry_group: group, tool_id: toolId, teen_id: teenId };
}

export function actionHistoryDayProps(
  teenId: string | null,
): Record<string, unknown> {
  return { teen_id: teenId };
}

export type ActionAiEntry = "button" | "shortcut";

export function actionAiOpenProps(
  entry: ActionAiEntry,
  teenId: string | null,
): Record<string, unknown> {
  return { entry, teen_id: teenId };
}

export function actionAiQuerySubmitProps(
  messageLength: number,
  teenId: string | null,
): Record<string, unknown> {
  return { message_length: messageLength, teen_id: teenId };
}

export function actionAiChipClickProps(
  promptId: string,
  teenId: string | null,
): Record<string, unknown> {
  return { prompt_id: promptId, teen_id: teenId };
}
